class ContentFloatingImageText {
  constructor(contentfulNode) {
    this.label = contentfulNode?.label;
    this.title = contentfulNode?.title;
    this.text = contentfulNode?.text;
    this.image = {
      fluid: contentfulNode?.image?.gatsbyImageData
    };
    this.imageAlignment = contentfulNode?.imageAlignment;
    this.imageCentered = contentfulNode?.imageCentered;
    this.type = 'CONTENT_FLOATING_IMAGE_TEXT';
  }
}

export { ContentFloatingImageText };
